import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment/moment';
import axios from 'axios';
import { CreateChancel, DateTypeSelect, SelectTypeAutocomplete } from 'components';
import { token, useModal } from 'utils';
import { clientNoteTypes } from '../../../fragments/client/clientSingle/core/constants';

export const DownloadClientCsv = ({}) => {
    const [error, setError] = useState('');
    const [inputs, setInputs] = useState({});
    const [load, setLoad] = useState(false);
    const { close } = useModal();
    // const navigate = useNavigate();
    // const info = location?.state;
    const data = useSelector((state) => state.client.clientItemInfo);

    // useEffect(() => {
    //     if (info) {
    //         const params = {
    //             staff: info?.staff,
    //             client: info?.client,
    //             type: info?.type,
    //             status: info?.status,
    //             startDate: info?.firstDate,
    //             endDate: info?.lastDate,
    //         };
    //         setInputs(params);
    //     }
    // }, [info]);

    const handleChange = (e) => {
        setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        error === e.target.name && setError('');
    };

    const handleExport = async () => {
        if (inputs?.noteType) {
            setLoad(true);
            const params = {};
            inputs?.noteType ? (params.noteType = inputs.noteType) : delete params.noteType;

            inputs?.startDate ? (params.startDate = moment.utc(inputs?.startDate).format('YYYY-MM-DD')) : delete params.startDate;
            inputs?.endDate ? (params.endDate = moment.utc(inputs?.endDate).format('YYYY-MM-DD')) : delete params.endDate;
            axios({
                url: `/reports/client/${data?.id}/notes`,
                method: 'GET',
                responseType: 'blob',
                headers: { 'access-token': `${token()}` },
                params: { ...params },
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response?.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `client-notes.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    setLoad(false);
                    close();
                })
                .catch(() => {
                    setLoad(false);
                    close();
                });
        } else {
            setError('noteType');
        }
    };

    return (
        <div className="download-payroll-csv-modal">
            <p className="download-modal-title">Download Notes PDF</p>
            <p className="download-modal-desc">
                Select the note type and date range for the data you wish to download. The fields will be pre-filled based on your current
                filter.
            </p>
            <div className="download-modal-body">
                <SelectTypeAutocomplete
                    title={'Note Type*'}
                    name={'noteType'}
                    placeholder={inputs?.noteType ? '' : 'All'}
                    handleSelect={handleChange}
                    defaultValue={inputs?.noteType}
                    list={clientNoteTypes}
                    renderValue={(i) => i?.name}
                    error={error}
                    typeError={error === 'noteType' ? 'Note Type is required' : ''}
                />
                <div className="start-end-time-box">
                    <DateTypeSelect
                        type={'modalInput'}
                        name={'startDate'}
                        outLabel={'Start Date'}
                        handleGetDates={handleChange}
                        values={inputs}
                        max={inputs.endDate ? moment.utc(inputs.endDate).format('YYYY-MM-DD') : ''}
                    />
                    <DateTypeSelect
                        type={'modalInput'}
                        name={'endDate'}
                        outLabel={'End Date'}
                        handleGetDates={handleChange}
                        values={inputs}
                        min={inputs.startDate ? moment.utc(inputs.startDate).format('YYYY-MM-DD') : ''}
                    />
                </div>
            </div>
            <div>
                <CreateChancel
                    loader={load}
                    create={'Download PDF'}
                    chancel={'Cancel'}
                    onCreate={handleExport}
                    onClose={() => close()}
                    buttonWidth="300px"
                />
            </div>
        </div>
    );
};
